// Facebook CAPI Configuration
export const FACEBOOK_CAPI_CONFIG = {
    API_VERSION: 'v22.0',
    PIXEL_ID: 598569026163339,
    ACCESS_TOKEN: "EAAMuFD8W83sBOZBpkVP4u9L3acO8NOs8gg5shSLGU2bTWNArWRqi4JrGXNaG9aBNgid0nr1nG1U4CSGXSWtIIn1DHVZCd6SIi6Ghv9sQi3W1t0EzcNdH1bB8ZA31t45WThvH4TFqFEKBUmO6AFGUYYH25AuHlvRsEZByRqL8azxRKgZBX1OaoYnHH0gGNpQTvOgZDZD",
    get BASE_URL() {
        return `https://graph.facebook.com/${this.API_VERSION}/${this.PIXEL_ID}/events`;
    }
};

export const FACEBOOK_CAPI_CONFIG_2 = {
    API_VERSION: 'v22.0',
    PIXEL_ID: 1698931937358791,
    ACCESS_TOKEN: "EAANEamSx4KQBO4HcgEOL6MrrZC7xMwMngPRbqMhgmdTl3tqnmVcQRB7R5M4my1RDsmHKZCcPWHUC99PZAZApZCZCkRQj1Jy3qtcO0T0KKZAkJpXpRWdVNfuOGDHA9ZC1zZCrBOYwDXmLCXAfvg4QfZCAOGBZBptCrqMMvokJhuE1BkX5GdHYiimrs1woS7mzCo74g06BAZDZD",
    get BASE_URL() {
        return `https://graph.facebook.com/${this.API_VERSION}/${this.PIXEL_ID}/events`;
    }
};

export const FACEBOOK_CAPI_CONFIG_3 = {
    API_VERSION: 'v22.0',
    PIXEL_ID: 625503420350787,
    ACCESS_TOKEN: "EAAIy1Lb7ZAjEBOy35Sfq5mvsmWQpoQgBIA2ZAbxhaPDhzH8SV0J30VgyUc4US0LMrR0kDDdm91I7Gw2EZBvvHzc7dU5CbyiPCZBpZB1AkrZCEWnncAD6ZCZCekKmdQul4lUDjazO3p2Ka69OjuyRHJWcQ102BM9GSAOZBobE7Doe6xkNUPCZAcODYzumbNtcRc7yZBVzAZDZD",
    get BASE_URL() {
        return `https://graph.facebook.com/${this.API_VERSION}/${this.PIXEL_ID}/events`;
    }
};

// Facebook Event Names
export const FACEBOOK_EVENTS = {
    PURCHASE: 'Purchase',
    ADD_TO_CART: 'AddToCart',
    INITIATE_CHECKOUT: 'InitiateCheckout',
    LOGIN: 'Login',
    PAYMENT: 'Payment',
    VIEW_CONTENT: 'ViewContent'
};

// Facebook Event Sources
export const EVENT_SOURCES = {
    WEBSITE: 'website',
    APP: 'app'
};

// Facebook Content Types
export const CONTENT_TYPES = {
    PRODUCT: 'product',
    SUBSCRIPTION: 'subscription'
};

// Default Currency
export const DEFAULT_CURRENCY = 'INR';

// User Data Fields
export const USER_DATA_FIELDS = {
    EMAIL: 'em',
    PHONE: 'ph',
    FIRST_NAME: 'fn',
    LAST_NAME: 'ln',
    DATE_OF_BIRTH: 'db',
    GENDER: 'ge',
    CLIENT_IP: 'client_ip_address',
    CLIENT_USER_AGENT: 'client_user_agent'
};

// Delivery Categories
export const DELIVERY_CATEGORIES = {
    INSTANT: 'instant',
    SCHEDULED: 'scheduled'
}; 